import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FloatingButton as FloatingButtonUiKit } from '@tecsinapse/ui-kit';

const styles = {
  button: {
    position: 'fixed',
    bottom: 80,
    right: 30,
    boxShadow: 'none',
    zIndex: 100,
  },
};

export const FloatingButton = withStyles(styles)(
  ({ classes, icon, disabled, ...props }) => (
    <FloatingButtonUiKit
      aria-label="add"
      className={classes.button}
      disabled={disabled}
      variantFab="warning"
      {...props}
    >
      {icon}
    </FloatingButtonUiKit>
  )
);
